import infinifiLogo from "@/assets/brand/infinifi-logo.svg";
import infinifiXLogo from "@/assets/brand/infinifi-x-logo.svg";
import infinifiDarkLogo from "@/assets/brand/infinifi-logo-dark.svg";

export const BRAND_LOGOS = {
    INFINIFI_LOGO: infinifiLogo,
    INFINIFI_DARK_LOGO: infinifiDarkLogo,
    INFINIFI_X_LOGO: infinifiXLogo,
} as const;
